const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

const headers = {
  'Content-Type': 'application/json',
  'x-api-key': 'scopingai',
};

export type HolidayRow = {
  id: string;
  name: string;
  date: string;
  state: string;
  created_at: string;
};

export type HolidayListParams = { search?: string; state?: string; year?: string; page?: number; limit?: number };
export type ListResponse<T> = { success: boolean; data?: T[]; count?: number; page?: number; limit?: number; error?: string };
export type MutateResponse<T> = { success: boolean; data?: T; error?: string };
export type BulkUploadResponse = {
  success: boolean;
  total?: number;
  inserted?: number;
  skipped?: number;
  errors?: Array<{ row: number; error: string }>;
  error?: string;
};

export const holidaysAdminService = {
  list: async (params: HolidayListParams = {}): Promise<ListResponse<HolidayRow>> => {
    try {
      const qs = new URLSearchParams();
      if (params.search) qs.set('search', params.search);
      if (params.state) qs.set('state', params.state);
      if (params.year) qs.set('year', params.year);
      qs.set('page', String(params.page ?? 1));
      qs.set('limit', String(params.limit ?? 25));
      const res = await fetch(`${API_BASE_URL}/api/holidays/list?${qs.toString()}`, { headers });
      return (await res.json()) as ListResponse<HolidayRow>;
    } catch (e) {
      return { success: false, error: e instanceof Error ? e.message : 'Request failed' };
    }
  },

  create: async (body: Omit<HolidayRow, 'id' | 'created_at'>): Promise<MutateResponse<HolidayRow>> => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/holidays`, {
        method: 'POST',
        headers,
        body: JSON.stringify(body),
      });
      return (await res.json()) as MutateResponse<HolidayRow>;
    } catch (e) {
      return { success: false, error: e instanceof Error ? e.message : 'Request failed' };
    }
  },

  update: async (id: string, body: Partial<Omit<HolidayRow, 'id' | 'created_at'>>): Promise<MutateResponse<HolidayRow>> => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/holidays/${id}`, {
        method: 'PATCH',
        headers,
        body: JSON.stringify(body),
      });
      return (await res.json()) as MutateResponse<HolidayRow>;
    } catch (e) {
      return { success: false, error: e instanceof Error ? e.message : 'Request failed' };
    }
  },

  bulkUpload: async (file: File): Promise<BulkUploadResponse> => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      const res = await fetch(`${API_BASE_URL}/api/holidays/bulk`, {
        method: 'POST',
        headers: { 'x-api-key': 'scopingai' },
        body: formData,
      });
      return (await res.json()) as BulkUploadResponse;
    } catch (e) {
      return { success: false, error: e instanceof Error ? e.message : 'Upload failed' };
    }
  },

  remove: async (id: string): Promise<{ success: boolean; error?: string }> => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/holidays/${id}`, {
        method: 'DELETE',
        headers,
      });
      return (await res.json()) as { success: boolean; error?: string };
    } catch (e) {
      return { success: false, error: e instanceof Error ? e.message : 'Request failed' };
    }
  },
};
